import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getCookies } from '../controllers/cookies.controller';

interface ProtectedRouteProps {
    children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

    useEffect(() => {
        const token = getCookies('token');
        setIsAuthenticated(!!token);
    }, []);

    // Enquanto verifica, não renderiza nada (evita flash de redirecionamento)
    if (isAuthenticated === null) {
        return null;
    }

    // Se não estiver autenticado, redireciona para login
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Se estiver autenticado, renderiza o componente
    return children;
};

export default ProtectedRoute;
